import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
import { OptionType } from '@shared/utils/Instruments/OptionType';
import { Instrument } from './Instrument';
export class OptionsCache {
    constructor(dataCache) {
        this.FAKE_OPTION_ROUTE = -1;
        this._optionsByInstrumentIdRouteId = new Map();
        this._dataCache = dataCache;
    }
    addOption(mess, route, underlier) {
        if (mess.TradableRoutes.length === 1 &&
            mess.RoutesSupported.length === 1 &&
            mess.TradableRoutes[0] !== mess.RoutesSupported[0] &&
            route === mess.RoutesSupported[0]) {
            return;
        }
        const optionMessage = structuredClone(mess);
        optionMessage.Name = underlier.ShortName;
        optionMessage.LanguageAliases = Instrument.CloneLangAliases(underlier.FLanguageAliases);
        optionMessage.Descr = underlier.Description;
        optionMessage.CountryId = underlier.CountryId;
        const option = this.getOptionInternal(optionMessage.Id, route);
        if (isNullOrUndefined(option)) {
            this.deleteFakeOption(optionMessage.Id);
            this.addOptionInternal(optionMessage, route, underlier, false);
        }
        else {
            option.UpdateByMessage(optionMessage);
        }
    }
    addFakeOption(mess, optionInfo, underlier) {
        const instrumentId = optionInfo.instrumentId.toString();
        const option = this.getFirstOptionById(instrumentId);
        if (!isNullOrUndefined(option)) {
            return;
        }
        const fakeOptionMess = structuredClone(mess);
        fakeOptionMess.Id = optionInfo.instrumentId.toString();
        fakeOptionMess.InstrType = InstrumentTypes.OPTIONS;
        if (isValidNumber(optionInfo.instrumentGroupId)) {
            fakeOptionMess.TypeId = optionInfo.instrumentGroupId;
        }
        fakeOptionMess.Name = underlier.ShortName;
        fakeOptionMess.LanguageAliases = Instrument.CloneLangAliases(underlier.FLanguageAliases);
        fakeOptionMess.Descr = underlier.Description;
        fakeOptionMess.CountryId = underlier.CountryId;
        this.addOptionInternal(fakeOptionMess, this.FAKE_OPTION_ROUTE, underlier, true);
    }
    clear() {
        this._optionsByInstrumentIdRouteId.clear();
    }
    findOptionByUnderlier(underlier) {
        if (isNullOrUndefined(underlier)) {
            return undefined;
        }
        const options = Object.values(this.getOptionInstruments(OptionsFilter.All));
        const option = options.find((opt) => opt.ForwardBaseInstrument.Id === underlier.Id && opt.ForwardBaseInstrument.Route === underlier.Route);
        if (isNullOrUndefined(option)) {
            return undefined;
        }
        if (option.optionType === OptionType.Fake) {
            return option;
        }
        const contractTradableId = underlier.isFuturesSymbol() ? underlier.InstrumentTradableID : undefined;
        return this.getOptionFromCacheById(option.Id, option.Route, contractTradableId);
    }
    getFirstOption(fakeInstrument) {
        const optionInstrument = this.getFirstOptionById(fakeInstrument.Id.toString());
        if (fakeInstrument.ForwardBaseInstrument.isFuturesSymbol()) {
            const underlierId = fakeInstrument.ForwardBaseInstrument.Id.toString();
            const underlierTradableId = fakeInstrument.ForwardBaseInstrument.InstrumentTradableID.toString();
            const contractUnderlier = this._dataCache.FindUnderlier(underlierId, optionInstrument.Route, underlierTradableId);
            return this.generateContractOption(optionInstrument, contractUnderlier);
        }
        else {
            return optionInstrument;
        }
    }
    getOptionFromCache(instrument) {
        const instrumentId = instrument.Id.toString();
        const route = instrument.Route;
        const option = this.getOptionInternal(instrumentId, route);
        if (isNullOrUndefined(option) || option.optionType === OptionType.Fake) {
            return undefined;
        }
        if (instrument.ForwardBaseInstrument.isFuturesSymbol()) {
            const underlierId = instrument.ForwardBaseInstrument.Id.toString();
            const underlierTradableId = instrument.ForwardBaseInstrument.InstrumentTradableID.toString();
            const contractUnderlier = this._dataCache.FindUnderlier(underlierId, option.Route, underlierTradableId);
            if (isNullOrUndefined(contractUnderlier)) {
                return undefined;
            }
            return this.generateContractOption(option, contractUnderlier);
        }
        else {
            return option;
        }
    }
    getOptionFromCacheById(optionId, optionRoute, contractTradableId) {
        const option = this.getOptionInternal(optionId.toString(), optionRoute);
        if (isNullOrUndefined(option) || option.optionType === OptionType.Fake) {
            return undefined;
        }
        if (isValidNumber(contractTradableId)) {
            return this.generateContractOption(option, this._dataCache.FindUnderlier(option.ForwardBaseInstrument.Id, option.ForwardBaseInstrument.Route, contractTradableId.toString()));
        }
        else {
            return option;
        }
    }
    getOptionInstruments(filter) {
        const optionInstruments = {};
        for (const instrumentId of this._optionsByInstrumentIdRouteId.keys()) {
            const instrumentsByRouteId = this._optionsByInstrumentIdRouteId.get(instrumentId);
            for (const route of instrumentsByRouteId.keys()) {
                const instrument = instrumentsByRouteId.get(route);
                let isAddOption = false;
                switch (filter) {
                    case OptionsFilter.All:
                        isAddOption = true;
                        break;
                    case OptionsFilter.Real:
                        isAddOption = instrument.optionType !== OptionType.Fake;
                        break;
                    case OptionsFilter.Fake:
                        isAddOption = instrument.optionType === OptionType.Fake;
                        break;
                }
                if (isAddOption) {
                    if (instrument.ForwardBaseInstrument.isFuturesSymbol()) {
                        const optionsByContract = this.generateContractOptions(instrument);
                        for (let i = 0; i < optionsByContract.length; i++) {
                            const optionByContract = optionsByContract[i];
                            const id = optionByContract.ForwardBaseInstrument.InstrumentTradableID;
                            optionInstruments[`${id}:${route}`] = optionByContract;
                        }
                    }
                    else {
                        optionInstruments[`${instrumentId}:${route}`] = instrument;
                    }
                }
            }
        }
        return optionInstruments;
    }
    getFirstOptionInstrument() {
        var _a, _b;
        const mapIteratorInstrumentIdKey = this._optionsByInstrumentIdRouteId.keys();
        const firstInstrumentIdKey = (_a = mapIteratorInstrumentIdKey.next()) === null || _a === void 0 ? void 0 : _a.value;
        if (isNullOrUndefined(firstInstrumentIdKey)) {
            return undefined;
        }
        const mapIteratorRouteIdKey = this._optionsByInstrumentIdRouteId.get(firstInstrumentIdKey).keys();
        const firstRouteIdKey = (_b = mapIteratorRouteIdKey.next()) === null || _b === void 0 ? void 0 : _b.value;
        if (isNullOrUndefined(firstRouteIdKey)) {
            return undefined;
        }
        return this._optionsByInstrumentIdRouteId.get(firstInstrumentIdKey).get(firstRouteIdKey);
    }
    getFirstOptionById(instrumentID) {
        if (!isValidString(instrumentID)) {
            return undefined;
        }
        const instrumentsByInstrumentId = this._optionsByInstrumentIdRouteId.get(instrumentID);
        if (isNullOrUndefined(instrumentsByInstrumentId)) {
            return undefined;
        }
        return Array.from(instrumentsByInstrumentId.values())[0];
    }
    generateContractOptions(option) {
        const result = [];
        const underlier = option.ForwardBaseInstrument;
        for (let i = 0; i < underlier.InstrDateSettingsList.length; i++) {
            const instrDateSettingsList = underlier.InstrDateSettingsList[i];
            const contractTradableId = instrDateSettingsList.InstrumentTradableID.toString();
            const contractUnderlier = this._dataCache.FindUnderlier(underlier.Id.toString(), option.Route, contractTradableId);
            result.push(this.generateContractOption(option, contractUnderlier));
        }
        return result;
    }
    generateContractOption(option, contractUnderlier) {
        const instrumentMessage = contractUnderlier.CreateInstrumentMessage();
        instrumentMessage.InstrType = InstrumentTypes.OPTIONS;
        instrumentMessage.Id = option.Id;
        instrumentMessage.TypeId = option.TypeId;
        instrumentMessage.InstrDateSettingsList = [
            option.InstrDateSettingsList.find((instrDateSettings) => instrDateSettings.UnderlierTradableId === contractUnderlier.InstrumentTradableID)
        ];
        const instrument = new Instrument(this._dataCache, instrumentMessage, option.Route);
        instrument.ForwardBaseInstrument = contractUnderlier;
        instrument.optionType = option.optionType;
        return instrument;
    }
    addOptionInternal(mess, route, underlier, isFake) {
        const instrumentID = mess.Id;
        let instrumentsByInstrumentId = this._optionsByInstrumentIdRouteId.get(instrumentID);
        if (isNullOrUndefined(instrumentsByInstrumentId)) {
            instrumentsByInstrumentId = new Map();
            this._optionsByInstrumentIdRouteId.set(instrumentID, instrumentsByInstrumentId);
        }
        const instrument = new Instrument(this._dataCache, mess, route);
        instrument.ForwardBaseInstrument = underlier;
        instrumentsByInstrumentId.set(route, instrument);
        if (isFake) {
            instrument.optionType = OptionType.Fake;
            instrument.isHideRouteMode = true;
        }
        else {
            instrument.optionType = OptionType.Real;
        }
        return instrument;
    }
    getOptionInternal(instrumentId, route) {
        if (!isValidString(instrumentId) || !isValidNumber(route)) {
            return undefined;
        }
        const instrumentsByInstrumentId = this._optionsByInstrumentIdRouteId.get(instrumentId);
        if (isNullOrUndefined(instrumentsByInstrumentId)) {
            return undefined;
        }
        return instrumentsByInstrumentId.get(route);
    }
    deleteFakeOption(instrumentId) {
        if (!isValidString(instrumentId)) {
            return;
        }
        const instrumentsByInstrumentId = this._optionsByInstrumentIdRouteId.get(instrumentId);
        if (isNullOrUndefined(instrumentsByInstrumentId)) {
            return;
        }
        const fakeOption = instrumentsByInstrumentId.get(this.FAKE_OPTION_ROUTE);
        if (isNullOrUndefined(fakeOption)) {
            return;
        }
        instrumentsByInstrumentId.delete(this.FAKE_OPTION_ROUTE);
    }
}
export var OptionsFilter;
(function (OptionsFilter) {
    OptionsFilter[OptionsFilter["All"] = 0] = "All";
    OptionsFilter[OptionsFilter["Real"] = 1] = "Real";
    OptionsFilter[OptionsFilter["Fake"] = 2] = "Fake";
})(OptionsFilter || (OptionsFilter = {}));
